module.exports = __webpack_public_path__ + "img/access-levels-executives.244c3721.png";